import { useOutletContext } from 'react-router-dom';
import { Content, Placeholder } from '@kinesis/bungle';
import { PathwayOutletContext } from '@/types';
import { Loading } from '@/components/loading';
import { PathwayResults } from '@/components/pathway-results';
import { useFlag } from '@/hooks/use-flag';

// The pathway detail's index view: the live evaluation of the effective
// (possibly-unsaved) pathway, rendered from the detail page's context —
// the page owns the simulate query so the editors share it. Not-configured
// (no base period yet) is a property of the pathway, shown as such; the
// download lives on the toolbar.
const PathwaySimulation = () => {
  const { evaluation, isEvaluating } = useOutletContext<PathwayOutletContext>();
  const showUndrivenNotice = useFlag('community.pathway-undriven-notice');

  if (!evaluation) {
    return isEvaluating ? <Loading /> : null;
  }
  if (evaluation.status === 'not-configured') {
    return (
      <Content
        alignX='center'
        textAlign='center'
        padding='medium'
        paddingMode='equal'
      >
        <Placeholder>
          This pathway has not been configured yet. Pick a base period end month
          to project from.
        </Placeholder>
      </Content>
    );
  }
  return (
    <Content padding='medium'>
      <PathwayResults
        evaluation={evaluation}
        showUndrivenNotice={showUndrivenNotice}
      />
    </Content>
  );
};

export { PathwaySimulation };
